import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M668.231 967.111H183.068A111.957 111.957 0 0 1 71.111 855.154v-634.44a111.957 111.957 0 0 1 111.957-111.957h485.163v858.354z" fill="#77D9FF" /><path d="M324.267 446.236H144.853a34.247 34.247 0 0 1-34.204-34.218 34.247 34.247 0 0 1 34.219-34.205H324.21a34.247 34.247 0 0 1 34.218 34.205 34.19 34.19 0 0 1-34.147 34.218z" fill="#FFF" /><path d="M200.32 501.76V322.347a34.247 34.247 0 0 1 34.204-34.205 34.247 34.247 0 0 1 34.22 34.205v179.342a34.247 34.247 0 0 1-34.22 34.219 34.19 34.19 0 0 1-34.204-34.148z" fill="#FFF" /><path d="M748.942 472.391a223.915 223.915 0 1 0-273.38 0 360.021 360.021 0 0 0-217.855 332.146v87.936a74.766 74.766 0 0 0 74.638 74.638H892.16a74.766 74.766 0 0 0 74.638-74.638v-87.936A360.021 360.021 0 0 0 748.942 472.39z" fill="#3889FF" /><path d="M721.636 864.242h-209.92c-22.073 0-40.022-15.332-40.022-34.205 0-18.887 17.949-34.218 40.022-34.218H721.55c22.073 0 40.022 15.331 40.022 34.218 0 18.873-17.878 34.205-39.965 34.205z" fill="#FFF" /></svg>

const AccountCenter = React.forwardRef((props, ref) => {
  return (
    <IconBase name="account-center" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

AccountCenter.displayName = 'IconAccountCenter'

export default AccountCenter
